// A lead's responsibles ("المسؤولون"). There are two ways onto the list:
// assigned by hand (MANUAL, removable), or by working on the lead (ACTIVITY,
// permanent — whoever changed a status, wrote a note, set a follow-up or sent a
// message stays accountable for that order). See LeadAssignee in the schema.

export type AssigneeSource = "MANUAL" | "ACTIVITY";

export interface LeadAssigneeView {
	source: AssigneeSource;
	user: { id: string; name: string };
}

export const ASSIGNEE_SOURCE_HINTS: Record<AssigneeSource, string> = {
	MANUAL: "أُسند يدوياً — يمكن إزالته",
	ACTIVITY: "عمل على الطلب — لا يمكن إزالته",
};

const ARABIC_LIST = new Intl.ListFormat("ar", { type: "conjunction" });

/** "سارة وأحمد" — how a lead's responsibles read inside a sentence. */
export function joinAssigneeNames(
	assignees: readonly { user: { name: string } }[] | null | undefined,
) {
	return ARABIC_LIST.format((assignees ?? []).map((a) => a.user.name));
}
